webpackJsonp([4],{

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DecodeTokenPage_vue__ = __webpack_require__(293);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a89524_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DecodeTokenPage_vue__ = __webpack_require__(313);
function injectStyle (ssrContext) {
  __webpack_require__(311)
}
var normalizeComponent = __webpack_require__(23)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64a89524"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DecodeTokenPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a89524_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DecodeTokenPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Common_FullViewLoading__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ManageTokenService__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(59);



//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DecodeTokenPage',
  components: { FullViewLoading: __WEBPACK_IMPORTED_MODULE_4__components_Common_FullViewLoading__["a" /* default */] },
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(['getSaleServicePointSettingsByToken', 'changeLoadingState'])),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(['tokenIsValid', 'isWaitingForSaleServicePointData'])),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var token;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              token = __WEBPACK_IMPORTED_MODULE_5__services_ManageTokenService__["a" /* default */].getTokenFromStorage() || _this.token;

              if (!token) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return _this.getSaleServicePointSettingsByToken(token);

            case 4:
              _context.next = 9;
              break;

            case 6:
              _this.changeLoadingState(false);
              _this.$router.push({ path: '/info' });
              return _context.abrupt('return');

            case 9:

              if (_this.tokenIsValid) {
                __WEBPACK_IMPORTED_MODULE_5__services_ManageTokenService__["a" /* default */].addTokenToStorage(token);
                _this.$router.push({ path: '/pay' });
              } else {
                __WEBPACK_IMPORTED_MODULE_5__services_ManageTokenService__["a" /* default */].removeTokenFromStorage();
                _this.$router.push({ path: '/error' });
              }

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(312);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(270)("a49765d0", content, true, {});

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(269)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spinner-data-v-64a89524{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner-data-v-64a89524{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.DecodeTokenPage[data-v-64a89524]{position:relative;width:100%;height:100%}", "", {"version":3,"sources":["/builds/Telestrada/payments.telestrada-online.pl/platform/src/views/DecodeTokenPage.vue"],"names":[],"mappings":"AACA,2CACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,mCACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,kCACE,kBAAmB,AACnB,WAAY,AACZ,WAAa,CACd","file":"DecodeTokenPage.vue","sourcesContent":["\n@-webkit-keyframes spinner-data-v-64a89524 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner-data-v-64a89524 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.DecodeTokenPage[data-v-64a89524] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DecodeTokenPage"},[(!_vm.isWaitingForSaleServicePointData)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.d1a2a886f38c41643ab7.js